import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IInventoryUpload } from "src/models/Products/InventoryUpload.models";

interface UploadState {
  uploads: IInventoryUpload[];
  uploadToEdit: IInventoryUpload | null;
}

const initialState: UploadState = {
  uploads: [],
  uploadToEdit: null,
};

const uploadInventorySlice = createSlice({
  name: "UploadInventory",
  initialState,
  reducers: {
    setUploadList: (state, action: PayloadAction<IInventoryUpload[]>) => {
      state.uploads = action.payload;
    },
    concatListUpload: (
      state: UploadState,
      action: PayloadAction<IInventoryUpload[]>
    ) => {
      state.uploads = [...state.uploads.concat(action.payload)];
    },
    setUploadToEdit: (state, action: PayloadAction<IInventoryUpload | null>) => {
      state.uploadToEdit = action.payload;
    },
    addUpload: (state, action: PayloadAction<IInventoryUpload>) => {
      state.uploads.push(action.payload);
    },
    applyDetails: (state, action: PayloadAction<number[]>) => {
      const newDetails = state.uploadToEdit?.details?.forEach(element => {
        if (action.payload.includes(element.uploadDetailId))
          element.applied = true;
        return element;
      })

      if (state.uploadToEdit) 
        state.uploadToEdit.details = newDetails ?? [];
    },
    updateUpload: (state, action: PayloadAction<IInventoryUpload>) => {
      let itemIndex = state.uploads.findIndex(
        item => item.uploadId === action.payload.uploadId
      );
      if (itemIndex !== -1) state.uploads[itemIndex] = action.payload;
    },
    deleteUpload: (state, action: PayloadAction<number>) => {
      const newArray = state.uploads.filter(
        item => item.uploadId !== action.payload
      );
      state.uploads = newArray;
    },
    deleteUploadMultipleDetails: (state, action: PayloadAction<number[]>) => {
      const newDetails = state.uploadToEdit?.details?.filter(
        item => !action.payload.includes(item.uploadDetailId) 
      );

      if (state.uploadToEdit) 
        state.uploadToEdit.details = newDetails ?? [];
    },
    deleteUploadDetail: (state, action: PayloadAction<number>) => {
      const newDetails = state.uploadToEdit?.details?.filter(
        item => action.payload != item.uploadDetailId
      );

      if (state.uploadToEdit) 
        state.uploadToEdit.details = newDetails ?? [];
    },
  },
});

export const {
  setUploadList,
  concatListUpload,
  setUploadToEdit,
  addUpload,
  applyDetails,
  updateUpload,
  deleteUpload,
  deleteUploadMultipleDetails,
  deleteUploadDetail,
} = uploadInventorySlice.actions;

export default uploadInventorySlice.reducer;